import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import * as globals from '../training/globals';

@Injectable({
  providedIn: 'root'
})
export class TrainingGuard implements CanActivate {

  canActivate(): boolean {
    const isAdmin = (localStorage.getItem(globals.POLICIES) === `${globals.TC}:${globals.trainingadmin}`);
    return isAdmin;
  }
}
